import { carDao } from 'shared/dao/carsDao';
import { useQuery } from 'react-query';
import { ICarsServiceProps } from 'shared/interfaces/ICars';

const {
  getManufacturer: getManufacturerDao,
  getModel: getModelDao,
  getVariant: getVariantDao,
  getSingleVariant: getSingleVariantDao,
} = carDao();

export const carService = () => {
  const getManufacturer = (data: ICarsServiceProps['manufactureProps']) => {
    return useQuery<ICarsServiceProps['manufacturerResponsePayload']>(
      ['manufacturer', data?.page],
      () => getManufacturerDao(data),
      {
        enabled: true,
      },
    );
  };

  const getModel = (data: ICarsServiceProps['modelProps']) => {
    return useQuery<ICarsServiceProps['modelResponsePayload']>(
      ['model', data?.manufacturerId, data?.page],
      () => getModelDao(data),
      {
        enabled: Boolean(data?.manufacturerId),
      },
    );
  };
  const getVariant = (data: ICarsServiceProps['variantProps']) => {
    return useQuery<ICarsServiceProps['variantResponsePayload']>(
      ['model', data?.manufacturerId, data?.modelName, data?.page],
      () => getVariantDao(data),
      {
        enabled: Boolean(data?.manufacturerId) && Boolean(data?.modelName),
      },
    );
  };
  const getSingleVariant = (data: ICarsServiceProps['singleVariantProps']) => {
    return useQuery<ICarsServiceProps['singleVariantResponsePayload']>(
      ['model', data?.variantId],
      () => getSingleVariantDao(data),
      {
        enabled: Boolean(data?.variantId),
      },
    );
  };

  return {
    getManufacturer,
    getModel,
    getVariant,
    getSingleVariant,
  };
};
